export default __webpack_public_path__ + "static/media/shoprite.4b4a9ee6.png";